import React from 'react';

// Modern (jjfv2) header / hero / footer
import HeaderV2 from '../../components/headerV2/HeaderV2';
import FooterV2 from '../../components/footerV2/FooterV2';
import AboutHero from '../../components/aboutHero/AboutHero';
import BlogSidebar from './BlogSidebar';

// CSS imoports
import '../AboutUsPage/aboutV2.css';
import './blogs.css';

// Image imports
import Blog1Img from "./../../images/blogs/the_pulse_of_change.webp";
import { Helmet } from 'react-helmet';

export default function ThePulseofChange() {
    return (
        <>  
            <Helmet>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@400;500;600;700;800&display=swap"
                    rel="stylesheet"
                />

                {/* Basic Meta Tags */}
                <title>The Pulse of Change Beats Through Every Hand | JJF India</title>
                <meta name="description" content="From green initiatives to mental health support, JJFIndia (Jainam Jivika Foundation) works to address today’s challenges and build a better future for everyone." />
                <meta name="keywords" content="JJFIndia, Jainam Jivika Foundation, Jainam and Jivika, Sevak Army, Life Saver Army, MindUnload, YoungJains, Akshay Netra, MyFoodChecker, Reform Army, Pledge My Organs" />
                <meta name="robots" content="index, follow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://jjfindia.com/our-bulletin/the-pulse-of-change-beats" />

                {/* Open Graph */}
                <meta property="og:title" content="The Pulse of Change Beats Through Every Hand | JJF India" />
                <meta property="og:description" content="From green initiatives to mental health support, JJFIndia (Jainam Jivika Foundation) works to address today’s challenges and build a better future for everyone." />
                <meta property="og:url" content="https://jjfindia.com/our-bulletin/the-pulse-of-change-beats" />

                {/* Twitter Cards */}
                {/* <meta name="twitter:card" content={metadata.twitter?.card} /> */}
                <meta name="twitter:title" content="The Pulse of Change Beats Through Every Hand | JJF India" />
                <meta name="twitter:description" content="From green initiatives to mental health support, JJFIndia (Jainam Jivika Foundation) works to address today’s challenges and build a better future for everyone." />
            </Helmet>

            <div className="jjfv2">
                <HeaderV2 />
                <AboutHero
                    eyebrow="Our Bulletin"
                    title="Blogs"
                    crumbs={[{ label: 'Home', to: '/' }, { label: 'Blogs' }]}
                />
            </div>
            <main className="page_content">
                    <div style={{paddingBottom: "60px", paddingTop: "60px"}} className="container">
                        <div className='single-blog-container' >
                            <div className="blog-article">
                                <h1>The Pulse of Change Beats Through Every Hand</h1>
                                <div>
                                    <img src={Blog1Img} alt='blog' />
                                </div>
                                <div style={{display: "flex", alignContent: "flex-end", width: "100%"}}>
                                    <span style={{ width:"100%", textAlign: "right", paddingTop: "16px", paddingBottom: "16px" }}>10 November, 2023</span>
                                </div>
                                <div>
                                    <p>Founded in 2017 by Jainam and Jivika, the Jainam Jivika Foundation (JJFIndia) has emerged as a beacon of hope and service, dedicated to creating lasting positive change in communities across India. Our mission is to create a lasting impact by focusing on the areas that matter most.</p>
                                    <p>We work across health awareness, mental well-being, cultural preservation, and environmental protection. By supporting community welfare and promoting green initiatives, we strive to address pressing challenges and make life better for everyone.</p>
                                    <p>Our efforts include running health campaigns, providing mental health support, and empowering communities with tools and resources to grow and thrive. At the same time, we actively work to preserve India’s rich cultural heritage and encourage sustainable living practices for a healthier, greener future.</p>
                                    <p>Over the years, JJFIndia has launched eight key initiatives to address diverse social challenges:</p>
                                    <ul>
                                        <li>Sevak Army – Mobilising volunteers for selfless service, disaster relief, and emergency response.</li>
                                        <li>Life Saver Army – Trained networks ready to respond during blood emergencies.</li>
                                        <li>MindUnload – A mental wellness platform providing support for stress, anxiety, and emotional wellbeing.</li>
                                        <li>YoungJains – Encouraging youth leadership, ethical values, and community service inspired by Jainism.</li>
                                        <li>Akshay Netra – Promoting awareness and support for eye donation.</li>
                                        <li>MyFoodChecker – Encouraging healthy, mindful eating habits.</li>
                                        <li>Reform Army – Driving civic participation and system-level improvements.</li>
                                        <li>Pledge My Organs – Facilitating organ donation awareness and pledges.</li>
                                    </ul>
                                    <p>To date, over 70,000 volunteers have registered with JJFIndia, and many outreach coordinators are actively working to spread awareness about issues that matter most, inspiring communities to participate in meaningful action.</p>
                                    <p>JJFIndia actively collaborates with NGOs, educational institutions, and local communities to design innovative and impactful initiatives. Recently, the Sevak Army, in partnership with the Kalki Foundation, organised a blood donation drive at BHU campus, resulting in over 73 registrations and 53 units of blood collected. The event highlighted the power of teamwork and reinforced the Foundation’s commitment to bringing fresh, meaningful ideas to community service.</p>
                                    <p>Through its initiatives, JJFIndia has reached thousands of people, creating opportunities, restoring hope, and inspiring volunteerism. Whether it’s distributing food, conducting blood donation drives, planting trees, or spreading awareness about mental wellness and organ donation, the Foundation exemplifies how collective compassion can drive real change. Looking ahead, Jainam Jivika Foundation aims to expand its reach, forge new collaborations, and continue innovating ways to serve society, proving that with empathy, dedication, and action, communities can be transformed for the better.</p>
                                </div>
                            </div>
                            <div>
                                <BlogSidebar />
                            </div>
                        </div>                    
                    </div>
                </main>
                <div className="jjfv2">
                    <FooterV2 />
                </div>
        </>
    );
}